import { render } from "./ScopeTwoSample.vue?vue&type=template&id=55c1a768"
import script from "./ScopeTwoSample.vue?vue&type=script&lang=js"
export * from "./ScopeTwoSample.vue?vue&type=script&lang=js"

import "./ScopeTwoSample.vue?vue&type=style&index=0&id=55c1a768&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QHeader from 'quasar/src/components/header/QHeader.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QHeader,QBtn});
